var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-radio-box"},[_c('label',[_c('BaseIcon',{attrs:{"name":_vm.iconName}}),_vm._v(" "),_c('input',_vm._g({attrs:{"type":"radio","name":_vm.name},domProps:{"value":_vm.optionValue,"checked":_vm.checked}},_vm.listeners)),_vm._v(" "),_c('p',[_vm._t("default")],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ba79440","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseRadioBox.vue
// module id = 936
// module chunks = 0